import { DialogComponent } from '@theme/dialog';

/**
 * Condition popup component extending Horizon's DialogComponent.
 * Adds: tab switching for condition tiers, video pause on close, GA4 tracking.
 */
export class OrchardConditionPopup extends DialogComponent {
  #parentCloseDialog;

  constructor() {
    super();
    // Store parent's closeDialog before we override it — class fields
    // are arrow functions and don't participate in prototype chain,
    // so super.closeDialog() doesn't work.
    this.#parentCloseDialog = this.closeDialog;
    this.closeDialog = this.#closeDialogWithVideoPause;
  }

  connectedCallback() {
    super.connectedCallback();

    for (const button of this.querySelectorAll('[role="tab"]')) {
      button.addEventListener('click', this.#onTabClick);
    }

    // Listen for external trigger (from variant-picker info icon)
    document.addEventListener('orchard:open-condition', this.#onExternalOpen);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('orchard:open-condition', this.#onExternalOpen);
  }

  #onExternalOpen = () => {
    this.showDialog();
  };

  showDialog() {
    // GA4 tracking (preserve from Dawn's openCondition function)
    if (typeof gtag === 'function') {
      gtag('event', 'condition_popup_click', {
        event_category: 'Product',
        event_label: 'Condition Popup Click',
      });
    }
    super.showDialog();
  }

  #closeDialogWithVideoPause = async () => {
    // Pause all videos before closing (from Dawn's pauseAllConditionVideos)
    for (const video of this.querySelectorAll('video')) {
      if (!video.paused) video.pause();
    }
    return this.#parentCloseDialog();
  };

  #onTabClick = (event) => {
    const button = event.currentTarget;
    const targetClass = button.dataset.target;

    // Update tab button states
    for (const btn of this.querySelectorAll('[role="tab"]')) {
      btn.classList.remove('con-active');
      btn.setAttribute('aria-selected', 'false');
    }
    button.classList.add('con-active');
    button.setAttribute('aria-selected', 'true');

    // Pause videos when switching tabs
    for (const video of this.querySelectorAll('video')) {
      if (!video.paused) video.pause();
    }

    // Hide all condition sections + text content
    for (const el of this.querySelectorAll('.condition-section, .condition-warranty__content:not(.global-text)')) {
      el.toggleAttribute('hidden', true);
    }

    // Show matching sections and text
    for (const target of this.querySelectorAll(targetClass)) {
      target.toggleAttribute('hidden', false);
    }
  };
}

if (!customElements.get('orchard-condition-popup')) {
  customElements.define('orchard-condition-popup', OrchardConditionPopup);
}
